const BRANDING_ENDPOINT =
    "/api/method/classvision_core.api.v1.branding.get_public_branding";


function isLoginPage() {
    const path =
        window.location.pathname
            .replace(/\/+$/, "");

    return (
        path === "/login"
        || path.endsWith("/login")
    );
}


function setFavicon(url) {
    if (!url) {
        return;
    }

    let link =
        document.querySelector(
            'link[rel="icon"]'
        );

    if (!link) {
        link =
            document.createElement(
                "link"
            );

        link.rel = "icon";

        document.head.appendChild(
            link
        );
    }

    link.href = url;
}


function setLogo(url) {
    if (!url) {
        return;
    }

    const selectors = [
        ".page-card-head img",
        ".app-logo",
        ".login-content img",
    ];

    document
        .querySelectorAll(
            selectors.join(",")
        )
        .forEach((image) => {
            image.src = url;
            image.alt =
                "Organization logo";
        });
}


function addBrandHeading(branding) {
    const card =
        document.querySelector(
            ".page-card"
        )
        || document.querySelector(
            ".login-content"
        );

    if (
        !card
        || document.getElementById(
            "cv-login-brand"
        )
    ) {
        return;
    }

    const container =
        document.createElement("div");

    container.id =
        "cv-login-brand";

    container.className =
        "cv-login-brand";

    const heading =
        document.createElement("h1");

    heading.textContent =
        branding.login?.heading
        || branding.organization?.name
        || "Welcome";

    const subheading =
        document.createElement("p");

    subheading.textContent =
        branding.login?.subheading
        || branding.organization?.tagline
        || "";

    container.appendChild(
        heading
    );

    if (subheading.textContent) {
        container.appendChild(
            subheading
        );
    }

    card.insertBefore(
        container,
        card.firstChild
    );
}


function applyLoginBranding(
    branding
) {
   if (
    !branding ||
    branding.enabled === false
) {
    return;
} 

    const root =
        document.documentElement;

    const colors =
        branding.colors || {};

    root.style.setProperty(
        "--cv-login-primary",
        colors.primary || "#2563EB"
    );

    root.style.setProperty(
        "--cv-login-primary-hover",
        colors.primary_hover
        || "#1D4ED8"
    );

    const backgroundImage =
        branding.login?.background_image || "";

    if (backgroundImage) {
        /*
         * JSON.stringify safely quotes spaces, commas,
         * parentheses and quotation marks in file URLs.
         */
        root.style.setProperty(
            "--cv-login-background-image",
            `url(${JSON.stringify(backgroundImage)})`
        );
    } else {
        root.style.removeProperty(
            "--cv-login-background-image"
        );
    }

    document.body.classList.add(
        "cv-branded-login"
    );

    document.body.dataset
        .cvBrandingVersion =
        branding.cache_version || "";

    const title =
        branding.organization
            ?.application_title;

    if (title) {
        document.title =
            `${title} | Login`;
    }

    setFavicon(
        branding.assets?.favicon
    );

    setLogo(
        branding.login?.logo
        || branding.assets?.brand_logo
    );

    addBrandHeading(
        branding
    );
}


async function initializeLoginBranding() {
    if (!isLoginPage()) {
        return;
    }

    try {
        const response =
            await fetch(
                BRANDING_ENDPOINT,
                {
                    method: "GET",
                    credentials:
                        "same-origin",
                    headers: {
                        Accept:
                            "application/json",
                    },
                }
            );

        if (!response.ok) {
            return;
        }

        const result =
            await response.json();

        const payload =
            result.message;

        if (
            !payload
            || payload.ok !== true
            || !payload.data
        ) {
            return;
        }

        applyLoginBranding(
            payload.data
        );
    } catch (error) {
        console.warn(
            "ClassVision login branding could not be loaded",
            error
        );
    }
}


if (
    document.readyState ===
    "loading"
) {
    document.addEventListener(
        "DOMContentLoaded",
        initializeLoginBranding,
        {
            once: true,
        }
    );
} else {
    initializeLoginBranding();
}
